import React from "react";

interface Props {
  isActive: boolean;
  isLarge?: boolean;
}

export default function PurchaseIcon({ isActive, isLarge = false }: Props) {
  return (
    <svg
      width={isLarge ? "40" : "20"}
      height={isLarge ? "44" : "22"}
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.516 1.16958C10.3767 1.03749 10.192 0.963867 10 0.963867C9.80802 0.963867 9.62334 1.03749 9.48401 1.16958C7.36128 3.18547 4.53413 4.29091 1.60701 4.24958C1.44754 4.24751 1.29157 4.29632 1.16173 4.38894C1.0319 4.48155 0.934963 4.61313 0.885007 4.76458C0.46298 6.05075 0.248625 7.39595 0.250007 8.74958C0.250007 14.6916 4.31401 19.6826 9.81301 21.0976C9.93567 21.1292 10.0643 21.1292 10.187 21.0976C15.686 19.6826 19.75 14.6916 19.75 8.74958C19.75 7.35958 19.527 6.01958 19.115 4.76458C19.0652 4.61294 18.9684 4.48114 18.8385 4.38834C18.7087 4.29554 18.5526 4.24658 18.393 4.24858L18.25 4.24958C15.254 4.24958 12.533 3.07958 10.516 1.16958ZM13.61 9.18558C13.67 9.10564 13.7134 9.0145 13.7377 8.91753C13.762 8.82057 13.7666 8.71973 13.7514 8.62094C13.7361 8.52215 13.7013 8.42741 13.6489 8.34228C13.5965 8.25715 13.5276 8.18336 13.4463 8.12523C13.3649 8.06711 13.2728 8.02583 13.1753 8.00381C13.0778 7.9818 12.9769 7.9795 12.8785 7.99705C12.7801 8.01459 12.6862 8.05164 12.6023 8.106C12.5184 8.16035 12.4462 8.23093 12.39 8.31358L9.15401 12.8436L7.53001 11.2196C7.38783 11.0871 7.19979 11.015 7.00548 11.0184C6.81118 11.0218 6.6258 11.1005 6.48839 11.238C6.35097 11.3754 6.27226 11.5608 6.26883 11.7551C6.2654 11.9494 6.33753 12.1374 6.47001 12.2796L8.72001 14.5296C8.797 14.6065 8.88981 14.6658 8.99199 14.7032C9.09418 14.7407 9.2033 14.7555 9.31177 14.7465C9.42024 14.7376 9.52546 14.7051 9.62014 14.6514C9.71481 14.5977 9.79666 14.5241 9.86001 14.4356L13.61 9.18558Z"
        fill={isActive ? "#5E9918" : "#B3B3B3"}
      />
    </svg>
  );
}
